export enum LoanRepaymentStatusType {
    None = 0,
    Part = 1,
    Full = 2,
}
